import { render } from "./Stock.vue?vue&type=template&id=93da2dbc"
import script from "./Stock.vue?vue&type=script&lang=ts"
export * from "./Stock.vue?vue&type=script&lang=ts"
script.render = render

export default script